import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import CheckMeter from '../Pages/CheckMeter'


export default function IndexRoutes() {
  return (
    <BrowserRouter>
        <Routes>
      
            <Route path='/' element={<CheckMeter/>}/>
          
        </Routes>
    </BrowserRouter>
  )
}
